import React, { useState, useEffect } from "react";
import {
  CCard,
  CCardHeader,
  CCardBody,
  CNavLink,
  CCardText,
  CImage,
  CRow,
  CCol,
  CButton,
} from "@coreui/react-pro";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
//import { getHotels } from "../../../BackendFirebase/getHotelsfromFirebase";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import LocationOnIcon from '@mui/icons-material/LocationOn';

import Select from "react-select";

const fetchHotelsFromDynamoDB = async () => {
  const apiUrl =
    "https://22d8lchkp9.execute-api.ap-southeast-2.amazonaws.com/getAllHotels";
  const response = await fetch(apiUrl);

  if (!response.ok) {
    throw new Error("Failed to fetch hotels from API Gateway");
  }

  const responseData = await response.json();
  console.log("Raw responseData:", responseData); // 输出原始响应

  return responseData; // 直接返回这个数组
};

//const apiKey = "AIzaSyBpWrR7G_jp8F1Q5LiXJZwqUxOQUiWHaD4";
//const apiKey = "AIzaSyAOE6N70QNQPgz46IT3knBnYFiqnFH3MNY";
const apiKey = "AIzaSyB85oa264g0eIIr0sCpzQw1Q0fXNjr7wzQ";
const sydneyCenter = { lat: -33.8688, lng: 151.2093 };
const defaultCenter = sydneyCenter;
const defaultZoom = 11;

const areaOptions = [
  {
    value: "Sydney CBD",
    label: "Sydney CBD",
    coordinates: { lat: -33.865143, lng: 151.2099 },
  },
  {
    value: "Bondi Beach",
    label: "Bondi Beach",
    coordinates: { lat: -33.8894, lng: 151.2734 },
  },
  {
    value: "Manly Beach",
    label: "Manly Beach",
    coordinates: { lat: -33.7985, lng: 151.2895 },
  },
];

const isMobile = window.innerWidth <= 768;


const HotelInfoCard = ({ hotel, onBookClick }) => {
  /* Should we remove the 'Reserve Shower' button and allow users to 
  navigate to the reservation page by clicking on the hotel card?
  const [isFirstClick, setIsFirstClick] = useState(true);
  const handleCardClick = () => {
    if (isFirstClick) {
      toast.info(
        "Proceed to reserve the shower room? Click the card again to confirm"
      );
      setIsFirstClick(false);
    } else {
      onBookClick(hotel);
    }
  };
  */
  const mobileStyle = {
    display: "flex",
    flexDirection: "row", // Change to row layout for mobile
    alignItems: "center",
    padding: "10px",
    boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#46D8B3",
    width: "100%",
  };

  const desktopStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#46D8B3",
    width: "100%",
  };

  const style = isMobile ? mobileStyle : desktopStyle;

  

  return (
    <div style={style} /*onClick={handleCardClick}*/>
      <img
        src={hotel.Shower_Room_Picture}
        alt={hotel.Hotel_Description}
        style={{
          width: isMobile ? "80px" : "120px",
          height: isMobile ? "80px" : "120px",
          objectFit: "cover",
          borderRadius: "8px",
          marginRight: isMobile ? "10px" : "0px",
        }}
      />
      {isMobile ? (
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h5
            style={{
              fontSize: "12px",
              marginBottom: "5px",
              textAlign: "center",
            }}
          >
            {hotel.Hotel_Description}
          </h5>
          <p
            style={{
              fontSize: "10px",
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            {hotel.Hotel_Location}
          </p>
          <button
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              backgroundColor: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() => onBookClick(hotel)}
          >
            Reserve Shower
          </button>
        </div>
      ) : (
        <>
          <div style={{ flex: 1, textAlign: "center", overflowY: "auto" }}>
            <h5 style={{ fontSize: "18px" }}>{hotel.Hotel_Description}</h5>
            <p style={{ fontSize: "16px" }}>{hotel.Hotel_Location}</p>
          </div>
          <button
            style={{
              padding: "10px",
              fontSize: "16px",
              backgroundColor: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() => onBookClick(hotel)}
          >
            Reserve Shower
          </button>
        </>
      )}
    </div>
  );
};

const MarkerWithInfoWindow = ({ hotel, onMarkerClick, map }) => {
  const [marker, setMarker] = useState(null);

  const ellipseWidth = 60; 
  const ellipseHeight = 30; 

  // 1.define createRectangleIcon 
  function createRectangleIcon(price) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = ellipseWidth;
    canvas.height = ellipseHeight;

    
    const cornerRadius = 20; 

    context.fillStyle = hotel.Shower_Room_Availability ? "rgba(70, 216, 179, 1)" : "#DCDCDC";
    //context.fillStyle = "rgba(70, 216, 179, 1)"; 
    context.roundRect(0, 0, ellipseWidth, ellipseHeight, cornerRadius);
    context.fill();
    //context.stroke();

    
    context.fillStyle = "black";
    context.font = "14px Arial";
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(price, ellipseWidth / 2, ellipseHeight / 2);

    return canvas.toDataURL();
  }

  
  CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    this.beginPath();
    this.moveTo(x + r, y);
    this.arcTo(x + w, y, x + w, y + h, r);
    this.arcTo(x + w, y + h, x, y + h, r);
    this.arcTo(x, y + h, x, y, r);
    this.arcTo(x, y, x + w, y, r);
    this.closePath();
    return this;
  };

  useEffect(() => {
    if (map && !marker) {
      const position = new google.maps.LatLng(
        hotel.Hotel_Latitude,
        hotel.Hotel_Longitude
      );
      const newMarker = new google.maps.Marker({
        position: position,
        title: hotel.Hotel_Price,
        icon: {
          url: createRectangleIcon(hotel.Hotel_Price),
          scaledSize: new google.maps.Size(ellipseWidth, ellipseHeight),
          anchor: new google.maps.Point(ellipseWidth / 2, ellipseHeight / 2),
        },
        zIndex: hotel.Shower_Room_Availability ? 1000 : 500,

        map: map,
      });

      newMarker.addListener("click", () => {
        onMarkerClick(hotel);
      });

      setMarker(newMarker);
    }

    return () => {
      if (marker) {
        google.maps.event.clearInstanceListeners(marker);
        marker.setMap(null);
      }
    };
  }, [map, marker]);

  return null;
};

const GoogleMapsComponent = () => {

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
    version: "weekly",
    language: "en",
  });

  const { hotels, handleBookShowerClick } = useHotelData();
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [map, setMap] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [showCard, setShowCard] = useState(false);

  useEffect(() => {
    if (selectedHotel) {
      setTimeout(() => {
        setShowCard(true); // 延迟设置，提供动画效果
      }, 100); // 可以调整这个延迟时间以优化动画效果
    } else {
      setShowCard(false);
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (isLoaded && !map) {
      const googleMap = new google.maps.Map(document.getElementById("map"), {
        center: defaultCenter,
        zoom: defaultZoom,
        gestureHandling: "greedy",
      });
      setMap(googleMap);
    }

    return () => {
      if (map) {
        google.maps.event.clearInstanceListeners(map);
      }
    };
  }, [isLoaded, map]);

  useEffect(() => {
    if (map) {
      if (selectedArea) {
        map.setCenter(selectedArea.coordinates);
        map.setZoom(15);
      } else {
        map.setCenter(defaultCenter);
        map.setZoom(defaultZoom);
      }
    }
  }, [map, selectedArea]);

  return (
    isLoaded && (
      <div
        style={{
          position: "relative",
          height: `calc(100vh - 90px)`,
          width: "100%",
        }}
      >
        <Select
          options={areaOptions}
          onChange={(selectedOption) => setSelectedArea(selectedOption)}
          isSearchable
          placeholder="Select your desired area..."
          styles={{
            container: (provided) => ({
              ...provided,
              width: "210px",
              position: "absolute",
              zIndex: 1,
              marginTop: "60px",
              marginLeft: "10px",
            }),
            control: (provided) => ({
              ...provided,
              backgroundColor: "#46D8B3",
              borderColor: "#46D8B3",
            }),
            placeholder: (provided) => ({
              ...provided,
              fontSize: "12px",
              color: "grey",
            }),
          }}
        />

        <div id="map" style={{ height: "100%", width: "100%" }}></div>
        {hotels.map((hotel) => (
          <MarkerWithInfoWindow
            key={hotel.Hotel_ID.toString()}
            hotel={hotel}
            onMarkerClick={setSelectedHotel}
            map={map}
          />
        ))}
        {selectedHotel && (
          <div
          style={{
            ...containerStyle,
            transform: showCard ? 'translateY(0)' : 'translateY(100%)' // 根据状态切换位置
          }}
          >
            <div
              style={{
                width: isMobile ? "75%" : "50%",
                backgroundColor: "#46D8B3",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <HotelInfoCard
                hotel={selectedHotel}
                onBookClick={handleBookShowerClick}
              />
            </div>
          </div>
        )}
      </div>
    )
  );
};

const containerStyle = {
  position: "absolute",
  bottom: 10,
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transform: 'translateY(100%)', // 开始时卡片完全隐藏
  transition: 'transform 0.3s ease-out' // 平滑过渡效果
};

const useHotelData = () => {
  const navigate = useNavigate();
  const [hotels, setHotels] = useState([]);

  const handleBookShowerClick = (hotel) => {
    if (hotel.Shower_Room_Availability) {
      navigate(`/book-shower/${hotel.Hotel_Description}`);
    } else {
      toast.error("Unfortunately not currently available!");
    }
  };

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const fetchedHotels = await fetchHotelsFromDynamoDB();
        console.log("Fetched hotels from DynamoDB:", fetchedHotels);
        fetchedHotels.sort((a, b) => a.Hotel_ID - b.Hotel_ID);
        setHotels(fetchedHotels);
      } catch (error) {
        console.error("Error fetching hotels:", error);
      }
    };

    fetchHotels();
  }, []);

  return { hotels, handleBookShowerClick };
};

const Map = () => {
  return (
    <div className="animated fadeIn" style={{ height: "100vh", width: "100%" }}>
      <GoogleMapsComponent />
    </div>
  );
};

export { GoogleMapsComponent };
export { useHotelData };
export default Map;
